import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import Popover from "react-bootstrap/Popover";
import { DownloadDocument } from "../Actions/ShipViewAPI";


class StaffCertificates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      currentPage: 0
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  renderPopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Download Report</label>
        </Popover.Content>
      </Popover>
    );
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }
  downloadDocument(attachmentDetail) {
    const { dispatch } = this.props;
    dispatch(DownloadDocument(attachmentDetail));
  }
  render() {
    const { arraylist, pageSize, totalRecords } = this.props;
    return (
      
      <div className="">
        {this.renderCardData()}
        {arraylist.data && arraylist.data.length ? (
          <Paginator
            first={this.state.currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div className="container">
                <h6 className="resource-list-title no-item-card">
                  No Purchase Orders
              </h6>
              </div>
            </div>
          )}
      </div>
    );
  }


  showPOView = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "POView", data: false });
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
  };

  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }

  renderCardData = () => {
    const { arraylist } = this.props;
    return arraylist.data && arraylist.data.length ? (
      <div className="row">
        {arraylist.data.map((item, index) => {
          return (
            <div className="col-sm-12 col-md-4 col-lg-3">
              <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                {item.ihmPresence == true ? (
                  <div className="arrow-left-red"></div>
                ) : (
                    <div className="arrow-left-green"></div>
                  )}
                <div className="p-4">
                  <div className="resource-list-auth-date">
                    <div className="row">
                      <div className="col-sm-12 col-md-12">
                        <div className="row">
                          <div className="col-sm-10 col-md-10 col-10 col-m-auto">
                            <div className="row">
                              <div className="col-sm-12 col-md-12">
                                <h6 className="resource-list-title title" onClick={() => this.showPOView(item.shipId, item.purchaseOrderId)} >{item.poNo} </h6>
                              </div>
                              <div className="col-sm-12 col-md-12"><span><strong>PO Date:</strong><span className="italicFont"> {Moment(new Date(Date.parse(item.poDate))).format('DD MMM YYYY')} </span></span></div>
                            </div>
                          </div>
                          <div className="col-sm-2 col-md-2 col-2 col-m-auto text-right">
                            <div className="vertical-center">
                              <i style={{ fontSize: "30px" }} className="fa fa-eye click mr-3" aria-hidden="true" onClick={() => this.showPOView(item.shipId, item.purchaseOrderId)}></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className={editPOView || showPODetail || editPendingTaskPresence || editPendingTaskRevision ? " col-sm-3 col-md-3 mt-5 text-right" : "col-sm-1 col-md-1 mt-4 text-right"}>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderPopover} >
                              <i className="fa fa-download click mr-3" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '1.5rem' }}>
                              </i>
                            </OverlayTrigger>
                          </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })
        }
      </div>
    ) : null

  };
}

function mapStateToProps(state) {
  return {
    PrevPos: state.SidePanReducer.PrevPos,
    //BY BALU MOORTHI
    editPOView: state.SidePanReducer.EditPOView || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StaffCertificates)
);
